import React from 'react'
import { Feed, Header, Modal, Button, Divider, List, Image, Grid } from 'semantic-ui-react';

import defaultLogo from './../../../../../images/logo/logo-128.png';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import Labels from './../../../../common/Labels';
import momentDate from '../../../../../helpers/momentDate';
import MomentTime from '../../../../common/MomentTime';
import ImageAvater from '../../../../drive/Components/ImageAvater';

class DeactivationLogModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleClose = () => {
        this.props.viewDeactivationLogs(false, this.props.account)
    }

    render() {
        let account = this.props.account;
        let user = this.props.user && this.props.user.accounts.filter((account) => {
            return account.name === "Aspenify Platform"
        })[0];

        let userRole = ''
        if (user) {
            userRole = user.role === 'platformAdmin' ? 'Platform Admin' : ''
        }

        return (
            <Modal
                open={this.props.isDeactivateLogModalOpen}
                onClose={this.handleClose}
                size='tiny'
                className="basicModal"
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >
                <Header content={"Account Logs"} ></Header>
                <Grid style={{ margin: "10px 20px 0" }}>
                    <Grid.Row className=' bg-clr-lightBlue' style={{ margin: "0", paddingBottom: '0px' }}>
                        <Grid.Column width={8}>
                            <Labels
                                text={<div >
                                    <div className="accountLogoTiny" style={{ margin: "3px 0 0 0" }} >
                                        <Image src={account && account.logo ? account.logo : defaultLogo} className="mar_0" />
                                    </div>
                                    <div className='float-left mar_5' >
                                        <EllipsisTooltip style={{ color: '#333' }} name={account && account.name} />
                                    </div>
                                </div>}
                            />
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Labels
                                text={<List horizontal >
                                    <List.Item>
                                        <ImageAvater user={account && account.ownerId} imageStyle="f_10 w_32 h_32 mar_0" />
                                        <div className="float-left f_12 pad_2 " >
                                            <EllipsisTooltip
                                                name={account && account.ownerId.firstName + ' ' + account.ownerId.lastName}
                                                line={2}
                                                style={{ 'lineHeight': '14px', padding: '0px 0px 2px 0px', color: '#333' }}
                                            />
                                            <span className="float-left f_10 pad_2 clr-dark-gray "><EllipsisTooltip
                                                name={account && account.ownerId.email}
                                                line={2}
                                                style={{ 'lineHeight': '14px', color: '#333' }}
                                            /></span>
                                        </div>
                                    </List.Item>
                                </List>}
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Divider style={{ margin: '5px 0' }} />
                <Modal.Content scrolling style={{ maxHeight: "calc(50vh)" }}>
                    {
                        this.props.actionLogs && this.props.actionLogs.length > 0 &&
                        this.props.actionLogs.map((actionLog, i) => {
                            let accountCreatedFeed = actionLog.action === "accountCreated" ?
                                <Feed
                                    className={`deactivateMessage bg-clr-lightBlue pad_5`}
                                    style={{ margin: "0 0 10px 0" }}
                                    key={i}>
                                    <Feed.Event className="pad_5">
                                        <ImageAvater user={actionLog.by} />
                                        <Feed.Content>
                                            <Feed.Summary>
                                                {actionLog.by.firstName + ' ' + actionLog.by.lastName}
                                                <span className="clr-blue">  created account </span>
                                                <span className="pull-right">{momentDate(actionLog.date)} </span>
                                            </Feed.Summary>
                                            <Feed.Date>
                                                <span>Account Owner</span>
                                                <span className="pull-right" style={{ textAlign: "right" }}>
                                                    <MomentTime date={actionLog.date} /> </span></Feed.Date>
                                        </Feed.Content>
                                    </Feed.Event>
                                </Feed>
                                : null
                            let deactivateFeed = actionLog.action === "deactivate" ?
                                <Feed className={`deactivateMessage bg-clr-lightBlue pad_5 `} style={{ margin: "0 0 10px 0" }}>
                                    <React.Fragment>
                                        <Feed.Event className="pad_5">
                                            <ImageAvater user={actionLog.by} />
                                            <Feed.Content>
                                                <Feed.Summary>
                                                    {actionLog.by.firstName + ' ' + actionLog.by.lastName}
                                                    <span className="clr-red">  deactivated account </span>
                                                    <span className="pull-right">{momentDate(actionLog.date)} </span>
                                                </Feed.Summary>
                                                <Feed.Date>
                                                    <span>{userRole}</span>
                                                    <span className="pull-right" style={{ textAlign: "right" }}>
                                                        <MomentTime date={actionLog.date} /> </span></Feed.Date>
                                            </Feed.Content>
                                        </Feed.Event>
                                        <Divider className="mar_lr_3" />
                                        <div className="pad_5 mar_0">
                                            <Labels
                                                name="Reason"
                                                text={actionLog.reason}
                                                htmlView={true}
                                            />
                                        </div>

                                    </React.Fragment>
                                </Feed> : null

                            let reactivateFeed = actionLog.action === "reactivate" ?
                                <Feed className={`deactivateMessage bg-clr-lightBlue pad_5 `} style={{ margin: "0 0 10px 0" }} >
                                    <React.Fragment>
                                        <Feed.Event className="pad_5">
                                            <ImageAvater user={actionLog.by} />
                                            <Feed.Content>
                                                <Feed.Summary>
                                                    {actionLog.by.firstName + ' ' + actionLog.by.lastName}
                                                    <span className="clr-green">  reactivated account </span>
                                                    <span className="pull-right">{momentDate(actionLog.date)} </span>
                                                </Feed.Summary>
                                                <Feed.Date>
                                                    <span>{userRole}</span>
                                                    <span className="pull-right" style={{ textAlign: "right" }}>
                                                        <MomentTime date={actionLog.date} /> </span></Feed.Date>
                                            </Feed.Content>
                                        </Feed.Event>
                                        <Divider className="mar_lr_3" />
                                        <div className="pad_5 mar_0">
                                            <Labels
                                                name="Reason"
                                                text={actionLog.reason}
                                                htmlView={true}
                                            />
                                        </div>
                                    </React.Fragment>
                                </Feed> : null


                            let accessGrantFeed = actionLog.action === "publicAccessGranted" ?
                                <Feed className={`deactivateMessage bg-clr-lightBlue pad_5 `} style={{ margin: "0 0 10px 0" }} >
                                    <React.Fragment>
                                        <Feed.Event className="pad_5">
                                            <ImageAvater user={actionLog.by} />
                                            <Feed.Content>
                                                <Feed.Summary>
                                                    {actionLog.by.firstName + ' ' + actionLog.by.lastName}
                                                    <span className="clr-green">  granted Publish to Public Library access</span>
                                                    <span className="pull-right">{momentDate(actionLog.date)} </span>
                                                </Feed.Summary>
                                                <Feed.Date>
                                                    <span>{userRole}</span>
                                                    <span className="pull-right" style={{ textAlign: "right" }}>
                                                        <MomentTime date={actionLog.date} /> </span></Feed.Date>
                                            </Feed.Content>
                                        </Feed.Event>
                                        <Divider className="mar_lr_3" />
                                        <div className="pad_5 mar_0">
                                            <Labels
                                                name="Reason"
                                                text={actionLog.reason}
                                                htmlView={true}
                                            />
                                        </div>

                                    </React.Fragment>
                                </Feed> : null
                            let accessRevokedFeed = actionLog.action === "publicAccessRevoked" ?
                                <Feed className={`deactivateMessage bg-clr-lightBlue pad_5`} style={{ margin: "0 0 10px 0" }} >
                                    <React.Fragment>
                                        <Feed.Event className="pad_5">
                                            <ImageAvater user={actionLog.by} />
                                            <Feed.Content>
                                                <Feed.Summary>
                                                    {actionLog.by.firstName + ' ' + actionLog.by.lastName}
                                                    <span className="clr-red">  revoked Publish to Public Library access</span>
                                                    <span className="pull-right">{momentDate(actionLog.date)} </span>
                                                </Feed.Summary>
                                                <Feed.Date>
                                                    <span>{userRole}</span>
                                                    <span className="pull-right" style={{ textAlign: "right" }}>
                                                        <MomentTime date={actionLog.date} /> </span></Feed.Date>
                                            </Feed.Content>
                                        </Feed.Event>
                                        <Divider className="mar_lr_3" />
                                        <div className="pad_5 mar_0">
                                            <Labels
                                                name="Reason"
                                                text={actionLog.reason}
                                                htmlView={true}
                                            />
                                        </div>

                                    </React.Fragment>
                                </Feed> : null

                            let integrationAddedFeed = actionLog.action === "integrationAdded" ?
                                <Feed
                                    className={`deactivateMessage bg-clr-lightBlue pad_5`}
                                    style={{ margin: "0 0 10px 0" }}
                                    key={i}>
                                    <Feed.Event className="pad_5">
                                        <ImageAvater user={actionLog.by} />
                                        <Feed.Content>
                                            <Feed.Summary>
                                                {actionLog.by.firstName + ' ' + actionLog.by.lastName}
                                                <span className="clr-green">  added integration </span>
                                                <span className="pull-right">{momentDate(actionLog.date)} </span>
                                            </Feed.Summary>
                                            <Feed.Date>
                                                <span>Account Owner</span>
                                                <span className="pull-right" style={{ textAlign: "right" }}>
                                                    <MomentTime date={actionLog.date} /> </span></Feed.Date>
                                        </Feed.Content>
                                    </Feed.Event>
                                </Feed>
                                : null

                            let integrationRemovedFeed = actionLog.action === "integrationRemoved" ?
                                <Feed
                                    className={`deactivateMessage bg-clr-lightBlue pad_5`}
                                    style={{ margin: "0 0 10px 0" }}
                                    key={i}>
                                    <Feed.Event className="pad_5">
                                        <ImageAvater user={actionLog.by} />
                                        <Feed.Content>
                                            <Feed.Summary>
                                                {actionLog.by.firstName + ' ' + actionLog.by.lastName}
                                                <span className="clr-red">  removed integration </span>
                                                <span className="pull-right">{momentDate(actionLog.date)} </span>
                                            </Feed.Summary>
                                            <Feed.Date>
                                                <span>Account Owner</span>
                                                <span className="pull-right" style={{ textAlign: "right" }}>
                                                    <MomentTime date={actionLog.date} /> </span></Feed.Date>
                                        </Feed.Content>
                                    </Feed.Event>
                                    <Divider className="mar_lr_3" />
                                        <div className="pad_5 mar_0">
                                            <Labels
                                                name="Reason"
                                                text={actionLog.reason}
                                                htmlView={true}
                                            />
                                        </div>
                                </Feed>
                                : null
                            return <div key={i} className="w_100 display-block float-left">
                                {accountCreatedFeed}
                                {deactivateFeed}
                                {accessRevokedFeed}
                                {accessGrantFeed}
                                {reactivateFeed}
                                {integrationAddedFeed}
                                {integrationRemovedFeed}
                            </div>
                        })
                    }
                    {
                        this.props.actionLogs && this.props.actionLogs.length === 0 ?
                            <span>No logs to display</span> : null
                    }
                </Modal.Content>
                <Divider style={{ margin: '5px 0' }} />
                <Modal.Actions className="actionInFormcy">
                    <Button
                        id='cancelBtn'
                        className="button-submit"
                        onClick={this.handleClose}
                        type="button"> Ok </Button>
                </Modal.Actions>
            </Modal >
        )
    }
}

export default DeactivationLogModal